import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Serverurl from './Apiurl';
import axios from 'axios';
import SyllabusPopUp from './SyllabusPopUp';
import "react-big-calendar/lib/css/react-big-calendar.css";
import notification from './images/notification-icon.png';
import { styled } from '@mui/material/styles';


moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default class SyllabusCalendar extends Component 
{
constructor(props) 
	  {
			super();
			
			this.state = {portionsData:[],popuptype:"1",poaid:0,celldate:'',edate:''}
			  this.updateDonenewParent = this.updateDonenewParent;
	  }
	  		componentWillMount() { 
		
localStorage.setItem("pageactive",12)
}
 handleSelect=(date)=>{
	console.log(date);
 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date1=date.getFullYear()+"-"+month+"-"+date1
	 this.setState({ poaid: 0 ,celldate:date1,edate:date});  

	  setTimeout(() => this.refs.SyllabusPopUp.handleClickOpen(),500);
 }
  handlePortions=(start,poaid)=>{
	
	   this.setState({ poaid: poaid });  
	   setTimeout(() => this.refs.SyllabusPopUp.handleClickOpen(),500);
  }
  updateDonenewParent = (text) => { this.PortionsAPIcall();  }
 componentDidMount() {
	 	document.title = "MM Coching Center - Portions Assign";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	 this.PortionsAPIcall();
	 
 }
PortionsAPIcall()
{let struserid="";
	if(localStorage.getItem("MMCrole")!=="1")
	 
		  { 
		  struserid=localStorage.getItem("MMCuserid");
		  }
axios.get(Serverurl+'ajaxportionsassigned.php?action=listcalendar')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({portionsData:resp.data});
			}
	   });
}
isDateInRange = (date, start, end) => {
    return date >= start && date <= end
  }
customDayPropGetter = (date) => {

  let data = this.state.portionsData
  
   var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date=date1+"/"+month+"/"+date.getFullYear()
   var obj = data.find((item, index) => {	   
	   
	   
	    if ((item.startdate === date && item.title !== "")  )
		 {
			 
			   return data[index]
		 }
		 
		
   });
 

   /* if(obj !== undefined && obj.startdate === date &&  obj.title !== "")
	{
	
        return { style: { backgroundColor: "#2588f5", Color:'#fff' } }
	}
    
        else {
			return { style: { backgroundColor: "#fff", Color:'#fff' } }
			}*/
				 
  
	
}

 eventStyleGetter=(event,start,end,isSelected)=>{

  
    var backgroundColor = '#2588f5' ;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: '#fff',
        border: '0px',
        display: 'block',
		textalign:'Center',
    };
    return {
        style: style
    };
}
render() {
  return (
    <div className="pagebox-col"> 
	<div className="boxheading">
	  <div className="contntpad">
	  <h2><img src={notification} />Syllabus Calender</h2>
	  </div> </div>
	
	<div className="contntpad">
	
	
<SyllabusPopUp ref="SyllabusPopUp" id={this.state.poaid} celldate={this.state.celldate} edate={this.state.edate} updateDonenew={this.updateDonenewParent}/>

      <Calendar
        views={["month"]}
        selectable
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
		dayPropGetter={this.customDayPropGetter }
        events={this.state.portionsData}
        style={{ height: "140vh" }}
        onSelectEvent={(event) => this.handlePortions(event.start,event.id)}
		 eventPropGetter={(this.eventStyleGetter)}
        onSelectSlot={(event)=>this.handleSelect(event.start)}
      /> </div>
    </div>
  );
}
}
